import script from "./Homepage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Homepage.vue?vue&type=script&setup=true&lang=ts"

import "./Homepage.vue?vue&type=style&index=0&id=2fd06668&lang=css"

const __exports__ = script;

export default __exports__